import I_STATE from './I_STATE';

const currentDate = new Date();

const INITIAL_STATE: I_STATE = {

  currentStep: 1,

  from_date: currentDate.getFullYear()+'-01-01',
  from_date_end: currentDate.getFullYear()+'-12-31',
  to_date: currentDate.getFullYear()+'-01-01',
  to_date_end: currentDate.getFullYear()+'-12-31',
  activity_types: [],
  directions_ops: [],
  hubs_ops: [],
  collaborators: [],
  // referential_customers: [],
  audited_customers: [],
  referentials: [],

  /** id des charges selectionnees pour le report */
  chargesIdSelected: [],
  chargesSelected: [],
  optionsFromDate: '', // a calculer a la selection des charges
  optionsVolumeChoice: 'keep',
  optionsVolumeRatio: 0, // si keep => 0
  optionsKeepActivities: true,
  optionsKeepCollaborator: true,
};
export default INITIAL_STATE;
